import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class UpdateAgentActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (!ProtectedEntitiesHelper.isComputer(record)) {
      return true;
    }

    if (record.specifics.isNsva) {
      return true;
    }

    if (record.specifics.serverHasNsxIntegration) {
      return false;
    }

    if (ProtectedEntitiesHelper.isComputer(record) && !record.specifics.isManaged) {
      return false;
    }

    if (record.specifics.isSandboxAnalyzer || record.specifics.isGhostr || record.specifics.isSva) {
      return false;
    }

    return true;
  }
}
